import { render, staticRenderFns } from "./FarmScreen.vue?vue&type=template&id=042639e3&scoped=true"
import script from "./FarmScreen.vue?vue&type=script&lang=js"
export * from "./FarmScreen.vue?vue&type=script&lang=js"
import style0 from "./FarmScreen.vue?vue&type=style&index=0&id=042639e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042639e3",
  null
  
)

export default component.exports